import React, { useState } from "react";
import { Outlet, useLocation } from "react-router-dom";
import styled, { keyframes } from "styled-components";
import Sidebar from "../components/Sidebar";

const ResponsiveSidebar = styled.div`
  @media (max-width: 900px) {
    display: none;
  }
`;

const ResponsiveMain = styled.div`
  margin-left: 240px;
  flex: 1;
  @media (max-width: 900px) {
    margin-left: 0;
  }
`;

const LayoutContainer = styled.div`
  display: flex;
  min-height: 100vh;
`;

const fadeIn = keyframes`
  from { opacity: 0; }
  to { opacity: 1; }
`;

const slideIn = keyframes`
  from { transform: translateX(-100%); }
  to { transform: translateX(0); }
`;

const MobileHeader = styled.div`
  display: none;
  align-items: center;
  gap: 12px;
  padding: 12px 16px;
  background: #fff;
  border-bottom: 1px solid #f0f0f0;
  position: sticky;
  top: 0;
  z-index: 50;

  @media (max-width: 900px) {
    display: flex;
  }
`;

const HamburgerButton = styled.button`
  width: 32px;
  height: 28px;
  display: inline-flex;
  flex-direction: column;
  justify-content: space-between;
  background: transparent;
  border: none;
  padding: 4px 2px;
  cursor: pointer;

  span {
    display: block;
    height: 3px;
    width: 100%;
    background: #222;
    border-radius: 2px;
  }
`;

const MobileOverlay = styled.div`
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.4);
  z-index: 150;
  animation: ${fadeIn} 160ms ease-out;
  @media (min-width: 901px) {
    display: none;
  }
`;

const MobileSidebarWrapper = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  height: 100vh;
  width: 240px;
  background: #fff;
  z-index: 200;
  animation: ${slideIn} 200ms ease-out;
`;

const SidebarLayout: React.FC = () => {
  const [mobileOpen, setMobileOpen] = useState(false);

  return (
    <LayoutContainer>
      <ResponsiveSidebar>
        <Sidebar />
      </ResponsiveSidebar>
      <ResponsiveMain>
        <MobileHeader>
          <HamburgerButton
            aria-label="Open sidebar"
            onClick={() => setMobileOpen(true)}
          >
            <span></span>
            <span></span>
            <span></span>
          </HamburgerButton>
        </MobileHeader>
        <Outlet />
      </ResponsiveMain>

      {mobileOpen && (
        <MobileOverlay onClick={() => setMobileOpen(false)}>
          {/* stop propagation so clicks inside the sidebar don't close it */}
          <MobileSidebarWrapper onClick={(e) => e.stopPropagation()}>
            <Sidebar />
          </MobileSidebarWrapper>
        </MobileOverlay>
      )}
    </LayoutContainer>
  );
};

export default SidebarLayout;
